export default __webpack_public_path__ + "static/media/bullets.2c54a00a.svg";